import styled from 'styled-components';

export default styled.div`
    height: 15%;
    padding: 10px;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    box-shadow: 0 0 1px black;
    align-items:center;
`
